import React, { useRef, useEffect, useState } from 'react';
import styles from './TeamSection.module.scss';
import { motion } from 'framer-motion';

// Import team images
import frankImg from '../assets/team/frank.jpeg';
import aaronImg from '../assets/team/aaron.jpeg';
import rafiImg from '../assets/team/rafi.jpg';
import peteImg from '../assets/team/pete.jpg';
import ronnieImg from '../assets/team/ronnie.jpeg';
import adrianImg from '../assets/team/adrian.jpg';
import hermanImg from '../assets/team/herman.jpg';
import nicholasImg from '../assets/team/nicholas.jpg';

const foundersTeam = [
  {
    name: 'Frank Teunissen',
    title: 'CEO & Founder',
    img: frankImg,
  },
  {
    name: 'Aaron Lutze',
    title: 'Co-Founder',
    img: aaronImg,
  },
  {
    name: 'Ahmad Rafi Wiratmoko',
    title: 'Co-Founder',
    img: rafiImg,
  },
  {
    name: 'Pete Whelan',
    title: 'Solutions Architect',
    img: peteImg,
  },
];

const advisorsTeam = [
  {
    name: 'Ronnie Hendricks',
    title: 'CEO & Buyers Agent',
    img: ronnieImg,
  },
  {
    name: 'Adrian Edwards',
    title: 'ASIC & Legal Advisor',
    img: adrianImg,
  },
  {
    name: 'Herman van Zyl',
    title: 'AFSL Holder',
    img: hermanImg,
  },
  {
    name: 'Nicholas Morrison',
    title: 'Buyers Agent',
    img: nicholasImg,
  },
];

const TeamSection = () => {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      if (rect.top < window.innerHeight - 100) setVisible(true);
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.25,
        delayChildren: 0.3
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.9, ease: "easeOut" }
    }
  };

  return (
    <section ref={ref} id="team" className={styles.section}>
      <motion.h2 
        className={styles.title}
        initial={{ opacity: 0, y: -15 }}
        animate={visible ? { opacity: 1, y: 0 } : { opacity: 0, y: -15 }}
        transition={{ duration: 0.8 }}
      >
        Our Team
      </motion.h2>
      
      <motion.h3
        className={styles.subtitle}
        initial={{ opacity: 0, y: -10 }}
        animate={visible ? { opacity: 1, y: 0 } : { opacity: 0, y: -10 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        Founders & Key Personnel
      </motion.h3>
      
      <motion.div 
        className={styles.grid}
        initial="hidden"
        animate={visible ? "visible" : "hidden"}
        variants={containerVariants}
      >
        {foundersTeam.map((member) => (
          <motion.div 
            key={member.name} 
            className={styles.card}
            variants={cardVariants}
          >
            <div className={styles.imgWrap}>
              <img src={member.img} alt={member.name} />
            </div>
            <div className={styles.name}>{member.name}</div>
            <div className={styles.role}>{member.title}</div>
          </motion.div>
        ))}
      </motion.div>

      <motion.h3
        className={styles.subtitle}
        initial={{ opacity: 0, y: -10 }}
        animate={visible ? { opacity: 1, y: 0 } : { opacity: 0, y: -10 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        Advisors
      </motion.h3>
      
      <motion.div 
        className={styles.grid}
        initial="hidden"
        animate={visible ? "visible" : "hidden"}
        variants={containerVariants}
      >
        {advisorsTeam.map((member) => (
          <motion.div 
            key={member.name} 
            className={styles.card}
            variants={cardVariants}
          >
            <div className={styles.imgWrap}>
              <img src={member.img} alt={member.name} />
            </div>
            <div className={styles.name}>{member.name}</div>
            <div className={styles.role}>{member.title}</div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default TeamSection;
